import {
    Component,
    EventEmitter,
    Input,
    Output,
    ViewEncapsulation,
} from '@angular/core';

export interface UnderlineTab {
    key: string;
    label: string;
    count?: number | null;
}

// SESSION-admin-ptg-003 — shared `.pm-tabs` underline tab strip. Used here for
// product-manage's three tabs; reusable wherever the proto specifies the same
// underline pattern (no `mat-tab-group`).
@Component({
    selector: 'app-underline-tabs',
    templateUrl: './underline-tabs.component.html',
    encapsulation: ViewEncapsulation.None,
})
export class UnderlineTabsComponent {
    @Input() tabs: UnderlineTab[] = [];
    @Input() activeKey: string | null = null;
    @Output() activeKeyChange = new EventEmitter<string>();

    select(key: string): void {
        if (this.activeKey === key) {
            return;
        }
        this.activeKey = key;
        this.activeKeyChange.emit(key);
    }
}
